import { Api } from "./api"

const PATH = 'formation' 
const ENDPOINTS = {
    Liste:'liste',
    Store:'store',
    Show:'show',
    Update:'update',
    Delete:'delete',
    Reactivate:'reactivate',
}

const getFormations = (signal) => {
    return Api.get(`${PATH}/${ENDPOINTS.Liste}`, signal)
}

const getFormationDetails = (id,signal) => {
    return Api.get(`${PATH}/${ENDPOINTS.Show}/${id}`, signal)
}

const storeFormation = (payload, signal) => {
    return Api.post(`${PATH}/${ENDPOINTS.Store}`, payload, signal)
}

const updateFormation = (id, payload, signal) => {
    return Api.post(`${PATH}/${id}/${ENDPOINTS.Update}`, payload, signal)
}

const deleteFormation = (id,signal) => {
    return Api.erase(`${PATH}/${ENDPOINTS.Delete}/${id}`, signal)
}

const reactivateFormation = (id, delayExpiration, signal) => {
    const payload = delayExpiration ? JSON.stringify({ delay_expiration: delayExpiration }) : JSON.stringify({});
    return Api.post(`${PATH}/${id}/${ENDPOINTS.Reactivate}`, payload, signal)
}

const deleteFormationMedia = (mediaId, signal) => {
    return Api.erase(`${PATH}/${mediaId}/delete-media-image`, signal)
}

export const formationApi = {
    getFormations,
    getFormationDetails,
    storeFormation,
    updateFormation,
    deleteFormation,
    reactivateFormation,
    deleteFormationMedia,
}